import { AbstractControl, ValidatorFn } from "@angular/forms";

export const rutValidator = (): ValidatorFn => {
  return (control: AbstractControl) => {
    const isValid = rutCheck(control.value);
    return isValid ? null : { rutValidator: isValid }
  }
}

export const rutCheck = (rut: string): boolean => {
  return validateRut(rut)
}

export const getDV = (T: any) => {
  let m = 0;
  let s = 1;
  T = parseInt(T);
  for (; T; T = Math.floor(T / 10)) {
    s = (s + (T % 10) * (9 - (m++ % 6))) % 11;
  }
  return s ? s - 1 : 'K';
}

export const validateRut = (nationalId: any) => {
  const checkRx = /^\d{7,9}-{0,1}[0-9Kk]/;

  let rut = nationalId;

  if (!nationalId) {
    return true;
  }
  rut = rut.replace(/\./g, '');
  if (!checkRx.test(rut.trim())) {
    return false;
  }


  const splitted = rut.slice(-1).toUpperCase();
  const str = rut.slice(0, rut.length - 1);

  if (!splitted) {
    return false;
  }

  const validate = splitted === getDV(str).toString();

  return validate;
}